import { defineStore } from 'pinia';
import * as _ from 'lodash';
import { CustomerData } from '../types/session';
import CustomersApi from '../api/CustomersApi';
import Segment from '../Segment';

export const useSessionStore = defineStore('session', {
  state: (): CustomerData => ({
    customerId: undefined,
    memberId: undefined,
    riseupAccountId: undefined,
    challenger: false,
  }),
  actions: {
    async init(): Promise<void> {
      const member = await CustomersApi.getPartiallyAuthenticatedMember();
      this.customerId = member.customerId;
      this.riseupAccountId = member.customerId;
      this.memberId = member._id;
      this.challenger = true;
      Segment.identifyCustomer(this.riseupAccountId, this.memberId);
    },
    setCustomerData(customerData: Partial<CustomerData>): void {
      // copying all fields from customerData to state without the need to check what fields are present
      _.assign(this, customerData);
    },
  },
});
